import AdminAddPasein from "../../components/AdminFinanceUserFee/FinanceUserFeeAdd";

export default function AddPasien() {
  return (
    <div style={{backgroundColor:"white"}}>
      <AdminAddPasein/>
    </div>
  );
}
